// import Navbar from "./components/navbar/Navbar.jsx";
// import Home from "./pages/home/Home.jsx";
// import About from "./pages/about/About.jsx";
// import Services from "./pages/services/Services.jsx";
// import Galary from "./pages/galary/Galary.jsx";
// import Contact from "./pages/contact/Contact.jsx";
// import Career from "./pages/career/Career.jsx";
// import ScrollToTop from "./components/ScrollToTop.js";
// import { HashRouter } from "react-router-dom";
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Feedbacks from "./pages/feedbacks/Feedbacks.jsx";
// import Layout from "./components/Layout.jsx";
// import Portfolio from "./pages/portfolio/Portfolio.jsx";
// import Blogs from './components/blogs/Blogs.jsx';
// import BlogDetails from './components/blogs/BlogDetails.jsx';
// function App() {
//   return (
//     <>
//       <HashRouter>
//         <ScrollToTop />
//         <Router>
//         <Routes>
//           <Route path="/" element={<Layout />}>
//             <Route index element={<Home />} />
//             <Route path="career" element={<Career />} />
//             <Route path="about" element={<About />} />
//             <Route path="services" element={<Services />} />
//             <Route path="contact" element={<Contact />} />
//             <Route path="gallery" element={<Galary />} />
//             <Route path="feedbacks" element={<Feedbacks />} />
//             <Route path="portfolio" element={<Portfolio />} />
//             <Route path="blogs" element={<Blogs />} />
//          <Route path="/blog/:id" element={<BlogDetails />} />
//           </Route>
//         </Routes>
//         </Router>
//       </HashRouter>
//     </>
//   );
// }

// export default App;
import Navbar from "./components/navbar/Navbar.jsx";
import Home from "./pages/home/Home.jsx";
import About from "./pages/about/About.jsx";
import Services from "./pages/services/Services.jsx";
import Galary from "./pages/galary/Galary.jsx";
import Contact from "./pages/contact/Contact.jsx";
import Career from "./pages/career/Career.jsx";
import ScrollToTop from "./components/ScrollToTop.js";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Feedbacks from "./pages/feedbacks/Feedbacks.jsx";
import Layout from "./components/Layout.jsx";
import Portfolio from "./pages/portfolio/Portfolio.jsx";
import Blogs from "./components/blogs/Blogs.jsx";
import BlogDetails from "./components/blogs/BlogDetails.jsx";
import BlogDetailsWrapper from './components/blogs/BlogDetailsWrapper.jsx';
import PrivacyPolicy from './pages/privacy/PrivacyPolicy.jsx';
import TermsAndConditions from './pages/privacy/TermsAndConditions.jsx';
import Journey from './pages/journey/Journey.jsx';
import TISPRT from "./pages/products/TISPRT.jsx";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="career" element={<Career />} />
          <Route path="about" element={<About />} />
          <Route path="journey" element={<Journey />} />
          <Route path="services" element={<Services />} />
          <Route path="contact" element={<Contact />} />
          <Route path="gallery" element={<Galary />} />
          <Route path="feedbacks" element={<Feedbacks />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="blog/:id" element={<BlogDetailsWrapper />} />
          <Route path="tisprt" element={<TISPRT />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
